
import MailingList from '../components/MailingList';
import Logo from "../assets/images/logo.png";
import {
  SiInstagram,
  SiYoutube,
  SiTiktok,
  SiFacebook,
  SiSpotify
} from "react-icons/si";

const neonColors = [
  "#ff00ff",
  "#00ffff",
  "#39ff14",
  "#ff3131",
  "#fff01f",
  "#ff5f1f",
  "#bc13fe",
  "#ff1493",
];

const randomNeon = (e) => {
  const randomColor =
    neonColors[Math.floor(Math.random() * neonColors.length)];

  e.currentTarget.style.color = randomColor;
  e.currentTarget.style.filter = `drop-shadow(0 0 8px ${randomColor})`;
};

const resetColor = (e) => {
  e.currentTarget.style.color = "";
  e.currentTarget.style.filter = "";
};

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        
        <MailingList />

        {/* Logo */}
        <div className="footer-brand text-center">
          <img
            src={Logo}
            alt="Nu Metal Kingdom logo"
            className="footer-logo"
          />

        </div>

        {/* Social Links */}
        <div className="footer-social">
          <a href="https://www.instagram.com/DyedToSelf" target="_blank" rel="noreferrer"
            onMouseEnter={randomNeon}
            onMouseLeave={resetColor}>
            <SiInstagram />
          </a>

          <a href="https://www.youtube.com/@DyedToSelf" target="_blank" rel="noreferrer"
            onMouseEnter={randomNeon}
            onMouseLeave={resetColor}>
            <SiYoutube />
          </a>

          <a href="https://www.tiktok.com/@DyedToSelf" target="_blank" rel="noreferrer"
            onMouseEnter={randomNeon}
            onMouseLeave={resetColor}>
            <SiTiktok />
          </a>

          <a href="https://www.facebook.com/DyedToSelf" target="_blank" rel="noreferrer"
            onMouseEnter={randomNeon}
            onMouseLeave={resetColor}>
            <SiFacebook />
          </a>


        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>&copy; {year} Dyed To Self. All Rights Reserved.</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;